import {z} from 'zod';
import {objectIdString} from '@packages/utilities/zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {translationExclusionUpdateZod} from '../../schemas';

const toolName = 'bulk-update-translation-exclusions' as const;

const argumentZod = z.object({
  ids: z
    .array(objectIdString)
    .min(1)
    .describe('The ids of the translation exclusion rules to update'),
  update: translationExclusionUpdateZod,
});

export const bulkUpdateTranslationExclusionsManifest =
  defineToolRegistryManifest({
    id: toolName,
    prettyName: 'Bulk update translation exclusion rules',
    prettyStatus: {
      executing: 'Updating translation exclusions…',
      executed: 'Updated translation exclusions',
      failed: 'Updating translation exclusions failed',
    },
    family: 'localization',
    llmTool: {
      name: toolName,
      description:
        'Updates the language and/or trigger scoping of one or more translation exclusion rules by id, for the current site. Provided fields replace the existing values -- they do not merge with them.',
      inputSchema: argumentZod,
    },
    type: 'server',
    requiredScopes: ['sites:write'],
    permission: [{resource: 'Site', action: 'update'}],
    confirmBeforeExecuting: true,
  });

export type BulkUpdateTranslationExclusionsArgumentType = z.infer<
  typeof argumentZod
>;
